module.exports = __webpack_public_path__ + "img/HealthHelp_Anxiety.21b8ae32.svg";